import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Indicator } from '../indicator/indicator';

@Component({
  selector: 'aor-indicator-slider',
  templateUrl: './indicator-slider.component.html',
  styleUrls: ['./indicator-slider.component.scss'],
})
export class IndicatorSliderComponent implements OnInit {
  @Input() brLabels: object = {};
  @Input() indicator?: Indicator;
  @Output() slideEvent = new EventEmitter<Indicator>();
  @Output() infoEvent = new EventEmitter<Indicator>();

  greyValue: number;

  setIndicatorValue(value: string | number): void {
    const indicatorValue = Number(value);

    this.indicator.data.value = indicatorValue;
    this.slideEvent.emit(this.indicator);
  }

  increment(): void {
    const value = this.indicator.data.value + 1;
    this.setIndicatorValue(value);
  }

  decrement(): void {
    const value = this.indicator.data.value - 1;
    this.setIndicatorValue(value);
  }

  showModal(): void {
    this.infoEvent.emit(this.indicator);
  }

  ngOnInit(): void {
    if (this.indicator) {
      this.greyValue = this.indicator.data.value;
    } else {
      this.greyValue = 0;
    }
  }

  selected(event) {
    this.setIndicatorValue(event.target.value);
  }
}
